import { FreeServicesParcelRequestGridComponent } from './free-services-parcel-request-grid.component';
import { FspParcelSearchFormModel } from '../fsp-parcel-search-form/fsp-parcel-search-form.model';
import {
  ColumnSetting,
  ColumnType,
  GenericGridToolbarItemName,
  GenericToolbarItemName,
  GridToolBarItem,
} from '../../../gk-kendo';
import {
  iwIconColorBud,
  iwIconColorKlu,
  iwIconColorLo,
  iwIconColorSz,
  iwIconPkt,
  iwIconPlus,
} from '../../../assets/css/ewid-svg/svg-icons';
import { AnyGeometryObject } from '../../../gk-map/models';

export const getFreeServicesParcelRequestGridToolbarItems = (
  c: FreeServicesParcelRequestGridComponent,
): GridToolBarItem[] => {
  return [
    {
      name: 'searchParcels',
      svgIcon: iwIconPlus,
      className: 'svg-icon-blue',
      title: 'FREE_PORTAL_SERVICES.SEARCH',
      text: 'FREE_PORTAL_SERVICES.SEARCH',
      showText: 'overflow',
      callback: () => c.openSearchParcelsWindow(),
    },
    {
      name: GenericToolbarItemName.GetPointGeometryFromMap,
      title: 'FREE_PORTAL_SERVICES.POINT_CASE',
      payload: () => ({
        doneCallback: (anyGeometryObject: AnyGeometryObject[]): void => {
          c.freeServicesParcelRequestGridDataService
            .queryByState(
              {
                filter: FspParcelSearchFormModel.fromAppToApi(
                  c.formModel,
                  c.freeServicesRequestListGridDataService.$selection.value
                    .selectedItems[0].ZamowUuid,
                  anyGeometryObject[0],
                ),
              },
              true,
              '/api/interesant/przp/dzialki/search',
            )
            .subscribe();
        },
      }),
    },
    {
      name: 'borderPoints',
      svgIcon: iwIconPkt,
      title: 'FREE_PORTAL_SERVICES.BORDER_POINTS',
      callback: () => c.handleOpenBorderPoints(),
    },
    {
      name: 'classUse',
      svgIcon: iwIconColorKlu,
      title: 'FREE_PORTAL_SERVICES.CLASS_USE',
      callback: () => c.handleOpenClassUse(),
    },
    {
      name: 'budilding',
      svgIcon: iwIconColorBud,
      title: 'FREE_PORTAL_SERVICES.BUILDINGS',
      callback: () => c.handleOpenBuildings(),
    },
    {
      name: 'premisses',
      svgIcon: iwIconColorLo,
      title: 'FREE_PORTAL_SERVICES.PREMISSES',
      callback: () => c.handleOpenPremisses(),
    },
    {
      name: 'requestDetails',
      svgIcon: iwIconColorSz,
      title: 'FREE_PORTAL_SERVICES.DETAILS',
      text: 'FREE_PORTAL_SERVICES.DETAILS',
      showText: 'overflow',
      callback: () => c.showDetailsWindow(),
    },
    {
      name: GenericGridToolbarItemName.ShowGeometry,
      payload: () => ({
        url: `/api/interesant/przp/zamowienie/${c.selectedRequestGridItem.ZamowUuid}/dzialka/{KdzialkaUuid}/geom`,
      }),
    },
    {
      name: 'print',
      iconClass: 'fa fa-print',
      title: 'FREE_PORTAL_SERVICES.PRINT',
      callback: () => c.downloadReport(),
    },
  ];
};

export const freeServicesParcelRequestGridColumns: ColumnSetting[] = [
  {
    field: 'Obreb',
    title: 'FREE_PORTAL_SERVICES.DISTRICT',
    type: ColumnType.Text,
  },
  {
    field: 'Adres',
    title: 'FREE_PORTAL_SERVICES.ADDRESS',
    type: ColumnType.Text,
  },
  {
    field: 'Numer',
    title: 'FREE_PORTAL_SERVICES.NUMBER',
    type: ColumnType.Text,
    width: 100,
  },
];
